export const openOrDownloadPdf = (link, blob, filename) => {
  if (validLink(link)) {
    const url = window.URL.createObjectURL(blob)
    return window.open(url)
  }
  downloadFile(link, blob, filename)
}

export const downloadFile = (link, blob, filename) => {
  return (navigator.msSaveBlob && navigator.msSaveBlob(blob, filename)) || createLink(link, blob, filename)
}

const createLink = (link, blob, filename) => {
  if (validLink(link)) {
    const url = window.URL.createObjectURL(blob)

    link.setAttribute('href', url)
    link.setAttribute('download', filename)

    link.style = 'visibility: hidden'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

const validLink = (link) => {
  return link.download !== undefined
}



// WEBPACK FOOTER //
// ./src/utils/downloads.js